import { render, staticRenderFns } from "./LessonEdit.vue?vue&type=template&id=52220dd1&scoped=true"
import script from "./LessonEdit.vue?vue&type=script&lang=js"
export * from "./LessonEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52220dd1",
  null
  
)

export default component.exports